<button class="edit-button" [disabled]="disabled" (click)="onClick()">
    <span class="edit-icon">
        <img src="/assets/icons/backoffice/edit-category.svg" alt="edit" />
    </span>
    <span class="edit-text">{{ label | translate }}</span>
</button>